<template>
  <auth-layout :heading="$t('heading')">
    <v-alert
      v-if="registrationError"
      :value="true"
      type="error">
      {{ $t('registrationError') }}
    </v-alert>
    <v-progress-linear
      v-else
      :indeterminate="true"/>

    <v-btn
      v-if="registrationError"
      slot="navigation"
      :to="{name: 'login'}"
      flat
    >
      {{ $t('back') }}
    </v-btn>

  </auth-layout>
</template>

<script>
import UserApi from '@/api/UserApi'
import AuthLayout from '@/components/layouts/AuthLayout'
import { mapActions } from 'vuex'

export default {
  name: 'RegistrationConfirm',
  components: { AuthLayout },
  props: [],
  data () {
    return {
      registrationError: false
    }
  },
  methods: {
    ...mapActions('user', ['setUser'])
  },
  async created () {
    try {
      const authObj = await UserApi.registrationConfirmation(this.$route.query.hash)
      UserApi.makeAuth(authObj)
      this.setUser(authObj.user)
      this.$router.push({ name: 'login' })
      this.$notification({
        success: {
          message: [this.$t('successfullyActivatedAccount')]
        }
      })
    } catch (e) {
      this.registrationError = true
      this.$notification(e)
    }
  },
  i18n: {
    messages: {
      de: {
        heading: 'Verifizierung läuft',
        successfullyActivatedAccount: 'Erfolgreich aktiviert',
        registrationError: 'Es ist ein Fehler aufgetreten',
        back: 'Zurück'
      },
      en: {
        heading: 'Verifying',
        successfullyActivatedAccount: 'Account activated',
        registrationError: 'An error occured',
        back: 'Back'
      },
      tr: {
        heading: 'Doğrulanıyor',
        successfullyActivatedAccount: 'Hesap etkinleştirildi',
        registrationError: 'Bir hata oluştu',
        back: 'Geri'
      },
      ru: {
        heading: 'Проверка',
        successfullyActivatedAccount: 'Аккаунт активирован',
        registrationError: 'Произошла ошибка при активации',
        back: 'Назад'
      }
    }
  }
}
</script>
